import React from 'react'
import {Button} from 'antd'
import {Link} from 'react-router-dom'

import {usersService} from 'services'
import FormHandler from 'components/Form/FormHandler'
import InputDecorated from 'components/Form/InputDecorated'
import FormContextProvider from 'components/Form/FormContextProvider'
import {logInUser} from 'utils/user'
import requestHandler from 'utils/requestHandler'
import useUserContext from 'components/User/useUserContext'

const AdditionalButton = <Link to='/register'><Button>Register</Button></Link>

const UserLogIn = ({history}) => {
  const {setUser} = useUserContext()

  const submitCallback = (values, setLoading) => {
    requestHandler(() => usersService.authEmail(values), 'json')
      .then(response => logInUser(response, history, setUser, setLoading))
  }

  return (
    <FormContextProvider>
      <FormHandler submitCallback={submitCallback} submitTitle='Log in' AdditionalButtons={AdditionalButton}>
        <InputDecorated fieldName='email' icon='mail' placeholder='Email'
                        rules={[
                          {required: true, message: 'Please input your Email'},
                          {type: 'email', message: 'The input is not valid Email'},
                        ]}/>
        <InputDecorated fieldName='password' icon='key' placeholder='Password' password
                        rules={[{required: true, message: 'Please input your password'}]}/>
      </FormHandler>
    </FormContextProvider>
  )
}

export default UserLogIn
